import axios from 'axios';

const http = axios.create({
  baseURL: "https://mgmt.vooster.io",
  headers: {
    'Content-type': 'application/json',
  },

});

export default http;